import { Component, OnInit, Input } from '@angular/core';
import { PlayerInfo } from '../../store-item';

import { MatDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ImgRequestService } from '../../services/img-request.service';

@Component({
  selector: 'app-celestial-panel',
  templateUrl: './celestial-panel.component.html',
  styleUrls: ['./celestial-panel.component.css']
})
export class CelestialPanelComponent implements OnInit {
  
  selectedRowIndex: number = 0;
  displayedColumns: string[];// = ['index', 'name', 'level', 'levelSub', 'levelSum', 'points', 'guild', 'kingdom'];

  @Input('dataSource') dataSource: PlayerInfo[];
  @Input('dataSource2') dataSource2: string;

  constructor(public dialog: MatDialog, public sanitizer:DomSanitizer, private imgService: ImgRequestService) { }

  ngOnInit() {
    if(this.dataSource2 == 'odin')
      this.displayedColumns = ['index', 'name', 'level', 'levelSub', 'levelSum', 'points', 'guild', 'kingdom'];
    else
      this.displayedColumns = ['index', 'name', 'level', 'levelSub', 'levelSum', 'guild', 'kingdom'];

    for (let item of this.dataSource) {
      if(item.isPlayer)
        this.selectedRowIndex = item.index;
    }
  }

  public getGuildMarkHTML(guildId: number): string {
    return this.imgService.getGuildMarkHTML(guildId, this.dataSource2);
  }

  public getKingdomHTML(kingdom: string): string {
    return this.imgService.getKingdomHTML(kingdom);
  }
}
